import { FeatureModule } from '@store/features/types';

export const formsFeature: FeatureModule = {
  id: 'forms',
  name: 'Forms',

  dependencies: [], // No dependencies for now

  reducers: {}, // No local state for now, just API

  middleware: [], // RTK Query middleware is already registered at the store level via baseApi

  // No persistence needed for now since we're just wrapping API calls
  persistence: {
    enabled: false,
  },

  // No sync needed for now
  sync: {
    enabled: false,
  },

  setup: store => {
    console.log(`${formsFeature.name} feature initialized`);
  },

  cleanup: store => {
    console.log(`${formsFeature.name} feature cleaned up`);
  },
};
